<template>
    <div class="m-userinfo">

        <p class="info-txt">
            <span>欢迎，</span>
            <span class="area-name" v-if="$store.state.login && $store.state.userinfo.areaId">【{{ area_dic[$store.state.userinfo.areaId] }}】</span>
            <span class="player-name">{{ ($store.state.userinfo.nickName || uid_handler($store.state.userinfo.uid) )|e }}</span>
            
            <span v-if="($store.state.login && !$store.state.userinfo.areaId)" class="bind" @click="$bind_modal()">【绑定大区】</span>

            <span v-if="$store.state.login && !KD.isApp() && $store.state.userinfo.uid" class="logout" @click="call_logout">【退出】</span>
            <span v-if="!$store.state.login || !$store.state.userinfo.uid" class="login" @click="call_login">【登录】</span>            
        </p>
       
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import mslogin from '@/assets/js/msLogin.js';
import area_dic from '@/components/areadic.js';
import { token_type } from '@/api/config';

export default {
    data (){
        return {
            KD : KD,
            area_dic : area_dic,
        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    filters : {
        e(str) {return str || '仙术师'}
    },    
    methods : {
        call_login(){
            mslogin.open();
        },

        call_logout(){
            var _this = this;
            // localStorage.removeItem(token_type);
            // localStorage.removeItem('account');
            // localStorage.removeItem('userinfo');
            // localStorage.removeItem('login');

            // setTimeout(function () { 
            //     //TODO   
            //     document.location = _this.$global.domain;
            // }, 100);
            
            this.$axios.get(this.$global.ajax_url_map.logout).then(
                res => {
                    localStorage.removeItem(token_type);
                    localStorage.removeItem('account');
                    localStorage.removeItem('userinfo');
                    localStorage.removeItem('login');

                    setTimeout(function () { 
                        //TODO   
                        document.location = _this.$global.domain;
                    }, 100);
                },
            )
        },

        call_buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }            

            this.$buy_Modal();
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },

        uid_handler(uid){
            return uid ? uid.toString().slice(0,6) + '****' : '仙术师'    
        },
    },
}
</script>

<style scoped>
.m-userinfo{
    position: absolute;
    top: -7px;
    left: 50%;
    width: 750px;
    height: 93px;
    /* line-height: 98px; */
    margin: 0 auto;
    font-size: 24px;
    /* text-align: center; */
    color: #d7b876;
    background-image: url(~@/assets/images/bg-user.png);
    transform: translateX(-50%);
}

.m-userinfo p{
    padding-left: 45px;
}

.u-btn.logout,
.u-btn.login{
    color: #ffeb76;
}

.login{
    position: absolute;
    /* float: right; */
    display: inline-block;
    width: 117px;
    height: 37px;
    top: 29px;
    right: 26px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/btn-login.png);
    cursor: pointer;
}


.logout {
    position: absolute;
    display: inline-block;
    /* float: right; */
    width: 117px;
    height: 37px;
    top: 29px;
    right: 26px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/btn-logout.png);
    cursor: pointer;
}

.info-txt{
    display: flex;
    align-items: center;
    height: 100%;
    margin: 0;
}

.player-name{
    display: inline-block;
    max-width: 300px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;        
}
</style>